import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { LegalsFooterBlockConfig } from '@front-platform/content-builder';
import { legalsFooterBlockResolveConfig } from '@front-platform/content-builder';
import { Component, computed, inject, Injector, input, runInInjectionContext } from '@angular/core';
import { getDoodLogoUrl, getDoodLogoWhiteUrl } from '@common/i18n/dood-logo-url';
import { getDoodBrand } from '@common/i18n/get-dood-brand';
import { resolveLegalsFooterColorsView } from './legals-footer-colors.util';
export interface LegalsFooterBlockRuntimeConfig {
  'extras'?: unknown[];
  'links'?: unknown[];
}

export type LegalsFooterBlockConfigInput = Partial<
  Omit<LegalsFooterBlockConfig, keyof LegalsFooterBlockRuntimeConfig> &
    LegalsFooterBlockRuntimeConfig
>;
export type LegalsFooterBlockResolvedConfig = Omit<
  LegalsFooterBlockConfig,
  keyof LegalsFooterBlockRuntimeConfig
> &
  Partial<LegalsFooterBlockRuntimeConfig>;
export interface LegalsFooterBlockContract extends ConfigComponentContract<
  LegalsFooterBlockConfigInput,
  LegalsFooterBlockResolvedConfig
> {}

@Component({
  selector: 'app-legals-footer-block',
  templateUrl: './legals-footer-block.component.html',
  standalone: false,
})
export class LegalsFooterBlockComponent implements LegalsFooterBlockContract {
  readonly config = input<LegalsFooterBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    LegalsFooterBlockConfig,
    LegalsFooterBlockRuntimeConfig
  >(legalsFooterBlockResolveConfig, () => ({ config: this.config() }));
  readonly extras = computed(() => this.resolvedConfig()['extras'] as unknown as unknown[]);
  readonly links = computed(() => this.resolvedConfig()['links'] as unknown as unknown[]);
  readonly displayPoweredByDood = computed(
    () => this.resolvedConfig()['display_powered_by_dood'] as unknown as boolean,
  );
  readonly colors = computed(() => resolveLegalsFooterColorsView(this.resolvedConfig()['colors']));

  private readonly injector = inject(Injector);

  protected readonly doodLogo = computed(() => {
    return runInInjectionContext(this.injector, () =>
      this.colors()?.logoColor === 'dark' ? getDoodLogoUrl() : getDoodLogoWhiteUrl(),
    );
  });
  protected readonly doodBrand = getDoodBrand();

  hasExtras(): boolean {
    return Array.isArray(this.extras()) && this.extras().length > 0;
  }

  hasLinks(): boolean {
    return Array.isArray(this.links()) && this.links().length > 0;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(LegalsFooterBlockComponent, { 'keyAliases': {} });
